export function normalizeChatErrorMessage(errorValue: unknown): string {
  const rawMessage =
    errorValue instanceof Error
      ? errorValue.message
      : typeof errorValue === "string"
        ? errorValue
        : "";
  const trimmedMessage = rawMessage.trim();
  const dataStreamError = trimmedMessage.match(/^3:(.+)$/s);

  if (dataStreamError) {
    try {
      return JSON.parse(dataStreamError[1]);
    } catch {
      return dataStreamError[1].replace(/^"|"$/g, "");
    }
  }

  return trimmedMessage || "请求失败，请稍后重试。";
}
